import React from 'react';
import propTypes from 'prop-types';
import styled from '@emotion/styled';
import {theme} from '../../../themes/default-theme';
import Text from '../../typography';
import { ButtonBase } from '@mui/material';
import { ReactSVG } from 'react-svg';
import adultSvg from '../../../assets/icons/floorplanAdult.svg';
import childSvg from '../../../assets/icons/floorplanChild.svg';
import plus from '../../../assets/icons/plus-btn.svg';
import minus from '../../../assets/icons/minus-btn.svg';


const Container = styled.div`

`

const Title = styled.h6`
    text-transform: uppercase;
    color: black;
    font-size: 16px;
    text-align: center;
    margin-bottom: 20px;
`

const Icons = styled.div`
    display: flex;
`

const Icon = styled(ButtonBase)`
    margin: 0 10px;
    width: 31px;
    cursor: pointer;
    svg {
        display: block;
        width: 25px;
        height: auto;
        margin: 0 auto;

        ${props => props.large && `
            width: 31px;
        `}

        [fill] {
            fill: #D8D8D8;
            ${props => props.active && `
                fill: ${theme.palette.vividBlue};
            `}
        }
    }
`

const Buttons = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 15px;
`

const Item = styled.div`
    display: flex;
    margin: 20px auto 40px;
    justify-content: center;
`

const Button = styled(ButtonBase)`
    width: 46px;
    height 46px;
    border-radius: 46px;
    svg {
        width: 100%;
        height: auto;
        display: block;
    }
`

const Value = styled.span`
    width: 30px;
    text-align: center;
    color: black;
    font-weight: bold;
    font-size: 16px;
`

const sleepSelectDefaultPropMax = {
    maxAdults: 0,
    maxChildren: 0,
};

const sleepSelectDefaultPropOnChange = () => {};

const SleepSelect = ({
    adults = 2,
    children = 2,
    max = sleepSelectDefaultPropMax,
    onChange = sleepSelectDefaultPropOnChange
}) => {
    const adultsArr = Array(max.maxAdults).fill(0);
    const childrenArr = Array(max.maxChildren).fill(0);

    return (
    	<Container>

            <Title>Adults</Title>
            <Item>
                <Icons>
                    {adultsArr.map((item, index) => {
                        return (
                            <Icon disableRipple={true} key={index} active={(index + 1) <= adults ? true : false}  onClick={() => onChange('adults', (index + 1))}>
                                <ReactSVG src={adultSvg} />
                            </Icon>
                        )
                    })}
                </Icons>
                <Buttons>
                    <Button onClick={() => onChange('adults', (adults - 1))}>
                        <ReactSVG src={minus} />
                    </Button>
                    <Value>{adults}</Value>
                    <Button onClick={() => onChange('adults', (adults + 1))}>
                        <ReactSVG src={plus} />
                    </Button>
                </Buttons>
            </Item>
            {childrenArr.length > 0 &&
                <>
                    <Title>Kids</Title>
                    <Item>
                        <Icons>
                            {childrenArr.map((item, index) => {
                                return (
                                    <Icon disableRipple={true} large="true" key={index} active={(index + 1) <= children ? true : false} onClick={() => onChange('children', (index + 1))}>
                                        <ReactSVG src={childSvg} />
                                    </Icon>
                                )
                            })}
                        </Icons>
                        <Buttons>
                            <Button onClick={() => onChange('children', (children - 1))}>
                                <ReactSVG src={minus} />
                            </Button>
                            <Value>{children}</Value>
                            <Button onClick={() => onChange('children', (children + 1))}>
                                <ReactSVG src={plus} />
                            </Button>
                        </Buttons>
                    </Item>
                </>
            }

        </Container>
    )
}

SleepSelect.propTypes = {
}

export default SleepSelect